import React from 'react'
import HeaderPdf from './pdfparts/header'

const Assessment = ({ charts, character, selectedUser }) => {
  const getColor = (value, threshold) => {
    if (value > threshold) {
      return 'green'
    } else if (value > 40) {
      return '#eba449'
    } else {
      return 'rgb(238, 67, 54)'
    }
  }

  const brainData = {
    memory: [charts.Brain_Strength.memory[0], charts.Brain_Strength.memory[2]],
    reasoning: [charts.Brain_Strength.thinking[0], charts.Brain_Strength.thinking[2]],
    association: [charts.Brain_Strength.association[0], charts.Brain_Strength.association[2]],
    visualization: [charts.Brain_Strength.vision[0], charts.Brain_Strength.vision[2]],
  }

  const brainSummary = Object.entries(brainData).reduce(
    (acc, [key, [actual, optimal]]) => {
      acc.totalActual += actual
      acc.totalOptimal += optimal

      if (actual > acc.highestCognitionValue) {
        acc.highestCognitionValue = actual
        acc.highestCognitionKey = key
      }

      return acc
    },
    { totalActual: 0, totalOptimal: 0, highestCognitionValue: -Infinity, highestCognitionKey: null }
  )

  const brainActual = Math.round(brainSummary.totalActual / 4)
  const brainOptimal = Math.round(brainSummary.totalOptimal / 4)
  const highestCognition = brainSummary.highestCognitionKey

  const cognition = {
    association: ['Prof Octopus', 'Agent Dolphin', 'Captian Whale'],
    reasoning: ['Cool Seal', 'Master Shark', 'Captian Whale'],
    memory: ['Cool Seal', 'Dr Penguin', 'Agent Dolphin'],
    visualization: ['Dr Penguin', 'Prof Octopus', 'Master Shark'],
  }

  return (
    <div className='page-break'>
      <HeaderPdf />

      <div className='pdf-content-container'>
        <div className='heading-seprator'>
          <h1>
            <span>ASSESSMENT</span>
          </h1>
        </div>
        <h4 className='my-4 fw-bolder'>Cognition Profile</h4>
        <div className='d-flex gap-5 '>
          <div>
            <img
              src={character.image}
              alt='personality-character'
              height={150}
              width={150}
              className='rounded-circle'
              style={{ objectFit: 'cover', border: '8px solid var(--primary-color)' }}
            />
          </div>
          <div>
            <h4
              className='px-3 py-1 fw-bolder'
              style={{
                width: 'fit-content',
                borderRadius: '12ch',
                borderBottomLeftRadius: '0px',
                backgroundColor: 'var(--primary-color)',
              }}
            >
              {character.title}
            </h4>
            <p className='fw-bolder fs-5 mb-2'>{character.desc[0]}</p>
            <p className='fs-6 mb-2' style={{ lineHeight: 'normal' }}>
              {character.desc[1]}
            </p>
            {/* <p className='fs-6 m-0' style={{ fontFamily: 'sorabold', color: 'green' }}>
              Family Cognition: <span className='text-uppercase'>'{highestCognition[0]}'</span> - {highestCognition}
            </p>
            <p>You can adapt to various roles that highlight your strengths. Diverse Characters : ({cognition[highestCognition].join(', ')})</p> */}
          </div>
        </div>
        <div className='d-flex align-items-center position-relative mt-5'>
          <div
            className='rounded-circle position-absolute bg-white'
            style={{ height: '150px', width: '150px', border: '12px solid rgb(65,139,212)', padding: '20px' }}
          >
            <div
              className='fs-3 fw-bold text-white rounded-circle d-flex justify-content-center align-items-center'
              style={{ height: '100%', width: '100%', background: 'rgb(65,139,212)' }}
            >
              {brainActual}%
            </div>
          </div>
          <div
            className='bg-secondary bg-opacity-10 py-2 w-100 ms-5'
            style={{ borderRadius: '12px', paddingLeft: '150px' }}
          >
            <p>
              Character Assigned Based on Strength: <span style={{ fontFamily: 'sorabold' }}>{character.title}</span>
            </p>

            <p className='m-0'>
              {brainActual >= brainOptimal ? 'Good' : brainActual >= 40 ? 'Medium' : 'Weak'} Cognitive Ability:
              <span style={{ fontFamily: 'sorabold' }}> {brainActual}%</span>
            </p>

            <p className='m-0'>
              Optimal Range: <span style={{ fontFamily: 'sorabold' }}> {brainOptimal}%</span>
            </p>
          </div>
        </div>
        <h4 className='mb-2 fw-bolder mt-5'>Evaluated Parameters</h4>
        <table
          className='table table-sm table-bordered text-center mb-4'
          style={{ tableLayout: 'fixed', borderRadius: '12px', overflow: 'hidden' }}
        >
          <thead>
            <tr className='bg-secondary bg-opacity-10'>
              <th>Evaluated</th>
              <th>Optimal</th>
              <th>{selectedUser.label}</th>
            </tr>
          </thead>
          <tbody className='border-top'>
            <tr>
              <th>Memory</th>
              <td>{brainData.memory[1].toFixed(0)}%</td>
              <td>
                <div
                  className='text-center text-white rounded-pill'
                  style={{
                    height: '100%',
                    width: '100%',
                    background: getColor(brainData.memory[0], brainData.memory[1]),
                  }}
                >
                  {brainData.memory[0].toFixed(0)}%
                </div>
              </td>
            </tr>
            <tr>
              <th>Reasoning</th>
              <td>{brainData.reasoning[1].toFixed(0)}%</td>
              <td>
                <div
                  className='text-center text-white rounded-pill'
                  style={{
                    height: '100%',
                    width: '100%',
                    background: getColor(brainData.reasoning[0], brainData.reasoning[1]),
                  }}
                >
                  {brainData.reasoning[0].toFixed(0)}%
                </div>
              </td>
            </tr>
            <tr>
              <th>Association</th>
              <td>{brainData.association[1].toFixed(0)}%</td>
              <td>
                <div
                  className='text-center text-white rounded-pill'
                  style={{
                    height: '100%',
                    width: '100%',
                    background: getColor(brainData.association[0], brainData.association[1]),
                  }}
                >
                  {brainData.association[0].toFixed(0)}%
                </div>
              </td>
            </tr>
            <tr>
              <th>Visualization</th>
              <td>{brainData.visualization[1].toFixed(0)}%</td>
              <td>
                <div
                  className='text-center text-white rounded-pill'
                  style={{
                    height: '100%',
                    width: '100%',
                    background: getColor(brainData.visualization[0], brainData.visualization[1]),
                  }}
                >
                  {brainData.visualization[0].toFixed(0)}%
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <h4 className='mb-2 fw-bolder'>Conclusion</h4>
         <p style={{ marginBottom: '4px', lineHeight: 'normal' }}>
          While{' '}
          <span className='fst-italic underline' style={{ fontFamily: 'sorabold' }}>
            {selectedUser.label}
          </span>{' '}
          has shown to have{' '}
          <span style={{ fontFamily: 'sorabold', color: 'var(--button-color)' }}>
            {brainActual >= brainOptimal ? 'good' : brainActual >= 40 ? 'average' : 'weak'}
          </span>{' '}
          cognitive well-being, we recommend training weakend cognitive skills and continuing to practice healthy
          lifestyle habits. We recommend starting a personalized brain training program using{' '}
          <span className='fw-bolder'>NEMA AI insights</span> in partnership with <span className='fw-bolder'>HPC</span>
        </p> */}

        {/* <p style={{ marginBottom: '4px', lineHeight: 'normal' }}>
          While{' '}
          <span className='fst-italic underline text-capitalize' style={{ fontFamily: 'sorabold' }}>
            {selectedUser.label}
          </span>{' '}
          has demonstrated{' '}
          <span style={{ fontFamily: 'sorabold', color: 'var(--button-color)' }}>
            {brainActual >= brainOptimal ? 'good' : brainActual >= 40 ? 'average' : 'weak'}
          </span>{' '}
          cognitive well-being, it is recommended to focus on enhancing weaker cognitive skills and maintaining healthy
          lifestyle habits. We advise initiating a personalized training program utilizing the NEMA insights, in
          collaboration with Holistic Psychotherapy Centre.
        </p> */}

        <div className='card-container mt-3'>
          <div className='card-list p-2 mb-0'>
            <div className='clr-box clr-box-green'></div>
            <div className='card-content'>
              {/* <h3>Green</h3> */}
              <p>
                Strong Cognitive <br /> Strength
              </p>
            </div>
          </div>
          <div className='card-list p-2 mb-0'>
            <div className='clr-box clr-box-yellow'></div>
            <div className='card-content'>
              {/* <h3>Yellow</h3> */}
              <p>
                Average Cognitive <br /> Strength
              </p>
            </div>
          </div>

          <div className='card-list p-2 mb-0'>
            <div className='clr-box clr-box-red'></div>
            <div className='card-content'>
              {/* <h3>Red</h3> */}
              <p>
                Weak Cognitve <br /> Strength
              </p>
            </div>
          </div>
        </div>
        <footer>
          <h6>02</h6>
        </footer>
      </div>
    </div>
  )
}

export default Assessment
